/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * ミッションの状態を表します。
 * @export
 * @interface MissionModel
 */
export interface MissionModel {
    /**
     * ミッションID
     * @type {number}
     * @memberof MissionModel
     */
    id?: number;
    /**
     * ミッションの達成状態 * 0：進行中　* 1：失敗
     * @type {number}
     * @memberof MissionModel
     */
    status?: number;
    /**
     * ミッションのリンク先
     * @type {string}
     * @memberof MissionModel
     */
    url?: string;
    /**
     * 
     * @type {number}
     * @memberof MissionModel
     */
    missionPromotionId?: number;
    /**
     * ミッションのタイトル
     * @type {string}
     * @memberof MissionModel
     */
    title?: string;
    /**
     * ミッションのタイプ
     * * 0: " "
     * * 1: "チュートリアル"
     * * 2: "デイリー"
     * * 3: "ウィークリー"
     * * 4: "マンスリー"
     * * 5: "イヤリー"
     * * 6: "キャンペーン"
     * @type {number}
     * @memberof MissionModel
     */
    type?: MissionModelTypeEnum;
    /**
     * ミッションの進歩
     * @type {number}
     * @memberof MissionModel
     */
    achievementCount?: number;
    /**
     * ミッションの達成ターゲット
     * @type {number}
     * @memberof MissionModel
     */
    targetAchievementCount?: number;
    /**
     * ミッションが達成する締め切りのUNIX時間
     * @type {number}
     * @memberof MissionModel
     */
    limit?: number;
}


/**
 * @export
 */
export const MissionModelTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
} as const;
export type MissionModelTypeEnum = typeof MissionModelTypeEnum[keyof typeof MissionModelTypeEnum];


/**
 * Check if a given object implements the MissionModel interface.
 */
export function instanceOfMissionModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MissionModelFromJSON(json: any): MissionModel {
    return MissionModelFromJSONTyped(json, false);
}

export function MissionModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MissionModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'missionPromotionId': !exists(json, 'missionPromotionId') ? undefined : json['missionPromotionId'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'achievementCount': !exists(json, 'achievementCount') ? undefined : json['achievementCount'],
        'targetAchievementCount': !exists(json, 'targetAchievementCount') ? undefined : json['targetAchievementCount'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function MissionModelToJSON(value?: MissionModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'status': value.status,
        'url': value.url,
        'missionPromotionId': value.missionPromotionId,
        'title': value.title,
        'type': value.type,
        'achievementCount': value.achievementCount,
        'targetAchievementCount': value.targetAchievementCount,
        'limit': value.limit,
    };
}

